import { useCallback, useEffect, useState } from 'react';
import groupServices from 'services/group.services';

export default function useGetGroupAccountType() {
  const [loading, setLoading] = useState(false);
  const [listAccountTypes, setListAccountTypes] = useState([]);

  const getAccountTypes = useCallback(async () => {
    try {
      setLoading(true);
      const data = await groupServices.listGroupAccountType();
      setListAccountTypes(data.items);
    } catch (err) {
      console.error(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getAccountTypes();
  }, []);

  return {
    loading,
    listAccountTypes,
    getAccountTypes
  };
}
